var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { store } from "./store";
import { UserRole } from "../shared/types/userSchema";


const ProtectedRoute = ({
  children,
  onlyAdmin



}) => {
  const userId = store === null || store === void 0 ? void 0 : store.getState().user.get('_id');

  if (onlyAdmin && (store === null || store === void 0 ? void 0 : store.getState().user.get('role')) === UserRole.ADMIN) {
    return children || /*#__PURE__*/_jsx(Outlet, {});
  }

  if (!onlyAdmin && userId) {
    return children || /*#__PURE__*/_jsx(Outlet, {});
  }

  return /*#__PURE__*/_jsx(Navigate, { to: "/login", replace: true });
};

const adminsOnlyRoute = (element) => /*#__PURE__*/
_jsx(ProtectedRoute, { onlyAdmin: true }, void 0, element);


const privateRoute = (element, settings) =>
!(settings !== null && settings !== void 0 && settings.private) ? element : /*#__PURE__*/_jsx(ProtectedRoute, {}, void 0, element);

const loggedInUsersRoute = (element) => /*#__PURE__*/_jsx(ProtectedRoute, {}, void 0, element);
export { loggedInUsersRoute, adminsOnlyRoute, privateRoute };